// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__B-uta","row":"Node_row__1Ih5h","label":"Node_label__2ftir","footer":"Node_footer__3JBua"};